import React from 'react';
import './AboutUs.css';

function AboutUs() {
    return (
        <div className="aboutus">
            <h1>About Us</h1>
            <div>
                <div className="aboutus__content">
                    <h3>WHAT WE DO?</h3>
                    <div className="aboutus__p">
                        <p>TOY CITY ZIMBABWE is a company based in Harare, Zimbabwe. With a couple of outlets in the country, the company is working on bringing fun and safe environment to its valid clients.</p>
                    </div>
                </div>
                <div className="aboutus__content">
                    <h3>WHY DO CUSTOMERS LOVE US?</h3>
                    <div className="aboutus__p">
                        <p>All our products are hand selected and consciously chosen for quality, safety, originality, fun and play value. You’ll find a unique selection of classic toys, educational toys, arts & crafts, wooden toys, construction toys, imaginative toys and more.  At Toy City Zimbabwe we believe in imaginative play over glue TV screens. We also have all Back to School products so our clients can get their needed products under one roof.</p>
                    </div>
                </div>
            </div>
            <h1>Locations</h1>
            <div>
                <div className="aboutus__content">
                    <h3>OUR BRACHES ARE AS FOLLOWS:</h3>
                    <div className="aboutus__p">
                        <p>Corner JASON MOYO AND MBUYA NEHANDA.</p>
                    </div>
                    <div className="aboutus__p">
                        <p>ALONG JULIUS NYERERE NEXT TO OK SUPERMARKET</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUs
